<template>
    <WidgetTitle
        :styles="content.styles"
        :translation="content.translation"
        :upload="content.upload"
    >
        <hooper class="mt-4" :settings="hooperSettings" style="height: 100%">
            <slide v-for="(testimonial, i) in testimonials" :key="i">
                <HomeTestimonialItem :font-color="content.styles.color" :testimonial="testimonial" />
            </slide>
            <template #hooper-addons><hooper-navigation></hooper-navigation></template>
        </hooper>
    </WidgetTitle>
</template>

<script>
import {
    Hooper,
    Slide,
    Navigation as HooperNavigation
} from 'hooper';
import WidgetTitle from '../Common/WidgetTitle'
import HomeTestimonialItem from './HomeTestimonialItem'

export default {
    name: 'HomeTestimonial',
    props: {
        content: {
            type: Object,
            require: true
        },
    },
    components: {
        Hooper,
        Slide,
        WidgetTitle,
        HooperNavigation,
        HomeTestimonialItem
    },
    data() {
        return {
            testimonials: this.content.contents,
            hooperSettings: {
                centerMode: false,
                breakpoints: {
                    360: {
                        itemsToShow: 1
                    },
                    576: {
                        itemsToShow: 2
                    },
                    1140: {
                        itemsToShow: 3
                    }
                }
            }
        }
    }
}
</script>

<style lang="css">
@import '../../../../../node_modules/hooper/dist/hooper.css';
</style>
